// Shell.tsx · v12.10.30.1 (#2264 left menu 'Help' -> 'Help desk', same caption as the page and the account menu) · 2026-11-03 · VoiceSpectrum AI
// Shell.tsx · v12.10.28 (#2179 tab title = the practice name only, no "VS ·") · 2026-11-01 · VoiceSpectrum AI
// Shell.tsx · v12.10.27 (#2179 tab title "VS · {practice}") · 2026-10-31 · VoiceSpectrum AI
// Shell.tsx · v12.10.25.2 (#2106 left-menu Help = /guides in the same window)
// Shell.tsx · v12.10.25.1 (#2106 Tushar 10/30: name menu 'Take the tour' / 'Check yourself')
// Shell.tsx · v12.10.25 (#2106 mounts the first-run host - Welcome, tours, checklist pill; name menu › Take the tour again / Show checklist)
// Shell.tsx · v12.10.23.1 (#2102 in the Help tab a menu item with no help topic for the person's rights is greyed, like in the app)
// Shell.tsx · v12.10.19 (#1894 the Staging bar and the "new version" bar sit where the Support banner sits - full width over the sidebar and the page; Staging text: only test-number data is cleared) · 2026-10-23 · VoiceSpectrum AI
// Shell.tsx · v12.10.15 (#1637 the Follow-ups number = the total of the picked pills, each follow-up once) · 2026-10-13 · VoiceSpectrum AI
// Shell.tsx · v12.10.13 (#1601 T87 Click Analyzer: installs uiTrack, reports the screen on show on every route change) · 2026-10-10 · VoiceSpectrum AI
// Shell.tsx · v12.10.12 (#1546 / #1550 Reports leaves "Coming soon" - it opens /reports for groups with Reports › Call activity)
// Shell.tsx · v12.10.12 (#1534 Follow-ups badge = the person's choice in Your account › Preferences, default due today) · 2026-10-10
// Shell.tsx · v12.10.11.3 (#1527 Follow-ups badge = every due follow-up (reminder today or overdue), from /t2/surface/message-counts, 999+) · 2026-10-09
// Shell.tsx · v12.10.11.3 (#1495 Help tab: no practice logo - the left column's top reads VoiceSpectrum Help, one full-width bar, Tushar 10/9) · 2026-10-09
// Shell.tsx · v12.10.11.2 (#1495 Help tab: left column joins the Help top bar, menu captioned HELP TOPICS) · 2026-10-09
// Shell.tsx · v12.10.11.1 (#1475 Help library) · 2026-10-09
// Shell.tsx · v12.10.10 (#1394 read-only Staging badge) · 2026-10-08 · VoiceSpectrum AI
// Shell.tsx · v12.10.9.4 (#1379 menu follows the user group; #1339 one letter / part before @; #1380 menu resets filters, refresh keeps; #1365 Leave goes back to the console) · 2026-10-07 · VoiceSpectrum AI
// VoiceSpectrum.Web.T2 · Shell · v12.10.9.3 (#1309 the whole sidebar card opens the menu; #1308 "Version x"; #1306 photo; #1329 a VoiceSpectrum Support visit shows the purple banner on every page - who, level, reason, Leave; "Configuration only" support sees Settings only) · 2026-10-07
// VoiceSpectrum.Web.T2 · v12.10.9.1 (profile card shows the person's name and main group · #1280 one 'Your account' entry) · v12.10.9 (Security Phase 1 – #1264/#1263) · 2026-10-06
// v12.10.9: the profile menu's "Your profile" and "Account settings" open the Your account drawer (openYourAccount) instead of /settings.
// Shell.tsx - v12.10.7.1 (#1186): the saved sidebar rail applies only above 980px - phones use the full width.
// Shell.tsx - v12.10.7 (#1163): Contacts leaves "Coming soon" - it opens /contacts.
// Shell.tsx - v12.10.5
// v12.10.5 (#1127): Contacts, Schedule, Reports, Billing and Help are shown but disabled - "Coming soon" on hover; their
// routes go to Messages (App.tsx). Nothing behind them is ready for a tenant yet.
// v12.1.29.0
// v12.1.29.0 (X): the sidebar "Follow-ups" nav shows a due-for-follow-up count badge (same value
// as the Messages "Due for follow-up" pill) and deep-links to /messages?filter=follow-up, which
// MessagesPage reads to auto-apply the dueOnly filter.
// Single shared tenant sidebar/skeleton (via <Outlet/>). Prototype: ai_agent_v1_5x.html.
// Profile menu is a floating popup (not inline) so it is never clipped by the sidebar overflow.
import { fuBadgeCount, useFuPref } from '../lib/followUpsPref';   // v12.10.12 (#1534)
import { ReactNode, useEffect, useRef, useState } from 'react';
import { clearSupportVisit, readSupportVisit } from '../lib/supportVisit';
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api, { mediaUrl } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useNavGuard } from '../lib/navGuard';
import { useVersionCheck } from '../lib/useVersionCheck';
import IdleLogoutGuard from './IdleLogoutGuard';
import MaintenanceOverlay from './MaintenanceOverlay';
import { openYourAccount } from './security/YourAccountDrawer';
import { HELP_DESK_MENU_LABEL, helpSupportUrl } from '../lib/helpDesk';   // v12.10.30 (#2259)
import { useAccess } from '../lib/useAccess';
import { HELP_RAILS, helpRailAllowed, type HelpCanOpen, type HelpRail } from '../pages/help/helpContent';   // v12.10.23.1 (#2102)
const HELP_RAIL_KEYS: string[] = HELP_RAILS.map((r) => r.key);
import { installUiTracking, screenFromPath, trackScreen } from '../lib/uiTrack';   // v12.10.13 (#1601)
import FirstRunHost from './firstrun/FirstRunHost';   // v12.10.25 (#2106)
import { FIRST_RUN_MENU_EVENT, sendFirstRun } from '../lib/firstRun';   // v12.10.25 (#2106)
import '../styles/tenant-skeleton.css';

const APP_VERSION: string =
  (import.meta as unknown as { env?: { VITE_APP_VERSION?: string } }).env?.VITE_APP_VERSION
  ?? 'unset';

function Svg({ d, className }: { d: ReactNode; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      {d}
    </svg>
  );
}
const IconMessages = () => <Svg d={<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-3.8-.8L3 21l1.9-5a8.4 8.4 0 0 1-.8-3.6 8.5 8.5 0 1 1 16.9.1z" />} />;
const IconFollowups = () => <Svg d={<path d="M12 8v4l3 2M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z" />} />;
const IconContacts = () => <Svg d={<><circle cx="9" cy="8" r="4" /><path d="M2 21a7 7 0 0 1 14 0M19 8v6M22 11h-6" /></>} />;
const IconSchedule = () => <Svg d={<><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></>} />;
const IconReports = () => <Svg d={<path d="M3 3v18h18M18 17V9M13 17V5M8 17v-3" />} />;
const IconBilling = () => <Svg d={<><rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" /></>} />;
const IconSettings = () => <Svg d={<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8 2 2 0 1 1-2.8 2.8 1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5 2 2 0 1 1-4 0 1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3 2 2 0 1 1-2.8-2.8 1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1 2 2 0 1 1 0-4 1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8 2 2 0 1 1 2.8-2.8 1.6 1.6 0 0 0 1.8.3 1.6 1.6 0 0 0 1-1.5 2 2 0 1 1 4 0 1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3 2 2 0 1 1 2.8 2.8 1.6 1.6 0 0 0-.3 1.8 1.6 1.6 0 0 0 1.5 1 2 2 0 1 1 0 4 1.6 1.6 0 0 0-1.5 1z" /></>} />;
const IconHelp = () => <Svg d={<><circle cx="12" cy="12" r="10" /><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01" /></>} />;
const IconChevronLeft = () => <Svg d={<path d="M15 18l-6-6 6-6" />} />;
const IconProfile = () => <Svg d={<><circle cx="12" cy="8" r="4" /><path d="M4 21v-1a6 6 0 0 1 12 0v1" /></>} />;
const IconSignout = () => <Svg d={<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5M21 12H9" /></>} />;

interface NavDef {
  soon?: boolean;   // v12.10.5 (#1127): shown, disabled, "Coming soon"
  newTab?: boolean;   // v12.10.11.1 (#1475): opens in a new browser tab (Help)
  denied?: boolean;   // v12.10.9.4 (#1379): the person's user group doesn't include it - greyed, not clickable
  key: string;
  label: string;
  to: string;
  icon: ReactNode;
  badge?: { value: string; amber?: boolean };
  match: (path: string) => boolean;
}

interface OrgIdentitySlim {
  identity?: { displayName?: string | null; legalName?: string | null; slug?: string | null; logoIconPath?: string | null; logoFullPath?: string | null };
}

// v12.10.11.3 (#1527): the left-menu badge counts every due follow-up (reminder today or overdue, any call date) on the server.
interface MessageCountsSlim {
  toWork: number;
  urgent: number;
  dueAll: number;
  /** v12.10.12 (#1534): every follow-up bucket - the badge shows the one the person picked in Your account. */
  followUps?: { overdue: number; today: number; week: number; future: number; all: number };
}
const localTodayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
const fmtBadge = (n: number) => (n > 999 ? '999+' : String(n));

export default function Shell() {
  const { claims, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const navGuard = useNavGuard();
  const { updateAvailable } = useVersionCheck();
  const [searchParams] = useSearchParams();
  const [railed, setRailed] = useState<boolean>(() => {
    try { return localStorage.getItem('vs_sidebar_rail') === '1'; } catch { return false; }
  });
  // v12.10.7.1 (#1186): below 980px the sidebar is the off-canvas drawer behind the menu button - the saved rail state
  // (a computer's choice) does not apply there, or the drawer opens as a row of icons and the page keeps a 72px column.
  const [narrow, setNarrow] = useState<boolean>(() => typeof window !== 'undefined' && window.matchMedia?.('(max-width: 980px)').matches === true);
  useEffect(() => {
    const mq = window.matchMedia?.('(max-width: 980px)');
    if (!mq) return;
    const on = () => setNarrow(mq.matches);
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, []);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState<'card' | 'top'>('card');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const supportMode = searchParams.get('support') === '1' || sessionStorage.getItem('vs.supportMode') === '1';

  useEffect(() => {
    if (searchParams.get('support') === '1') sessionStorage.setItem('vs.supportMode', '1');
  }, [searchParams]);

  const { data: org } = useQuery<OrgIdentitySlim>({
    queryKey: ['t2-organization-settings'],
    queryFn: () => api.get<OrgIdentitySlim>('/t2/settings/organization'),
    staleTime: 60_000,
    retry: false,
  });

  // X: the Follow-ups nav badge mirrors the Messages "Due for follow-up" count - messages that
  // are not done and carry a reminder. Read the same /t2/surface/messages envelope MessagesPage
  // uses so the two counts stay in lockstep; refetch on window focus keeps it fresh after edits.
  // v12.10.9.3 (#1329): a "Configuration only" support visit can't read messages - no badge call.
  const { me: secMeEarly, canOpen } = useAccess();
  // v12.10.23.1 (#2102): the same check the Help page uses ('*settings' = any Settings / Security area).
  const helpCan: HelpCanOpen = (k: string) => (k === '*settings'
    ? (secMeEarly ? Object.entries(secMeEarly.access ?? {}).some(([key, v]) => (key.startsWith('s:') || key.startsWith('sec_')) && (v ?? []).length > 0) : true)
    : canOpen(k));
  // v12.10.10 (#1394): the practice's mode - a read-only Staging badge while VoiceSpectrum has it in test mode.
  const { data: practiceMode } = useQuery<{ mode?: string }>({ queryKey: ['t2-practice-mode'], queryFn: () => api.get('/t2/security/practice-mode'), staleTime: 300_000, retry: false });
  const staging = practiceMode?.mode === 'staging';
  const supportConfigOnly = !!secMeEarly?.isSupport && secMeEarly.support?.level === 'config';
  // v12.10.9.4 (#1379): the left menu follows the person's user group, like Settings already does. Unknown -> shown.
  const canMessages = canOpen('phone') || canOpen('texts');
  const canContacts = canOpen('contacts');
  const todayIso = localTodayIso();
  const { data: msgCounts } = useQuery<MessageCountsSlim>({
    queryKey: ['t2-message-counts', todayIso],
    queryFn: () => api.get<MessageCountsSlim>(`/t2/surface/message-counts?today=${todayIso}`),
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: false,
    enabled: !supportConfigOnly && canMessages,   // v12.10.9.4 (#1379)
  });
  // v12.10.12 (#1534): the badge counts what the person picked in Your account › Preferences (default: due today).
  const fuPref = useFuPref();
  const dueCount = fuBadgeCount(fuPref, msgCounts?.followUps, 0);

  const slug = org?.identity?.slug || claims?.tenant_slug || 'workspace';
  const tenantName = org?.identity?.displayName || org?.identity?.legalName || claims?.tenant_slug || 'Workspace';
  // v12.10.27 (#2179): the browser tab names the practice - "VS · Serena Lee" (the VS icon is the favicon), so a tiny
  // tab still says which practice it is. A leading "Dr." is dropped to keep it short; Help sets its own title on top.
  const tabName = tenantName.replace(/^\s*dr\.?\s+/i, '').trim();
  useEffect(() => {
    if (!org) return;
    if (location.pathname.startsWith('/help')) return;   // HelpPage names the article
    document.title = tabName;   // v12.10.28 (#2179 reopened, Tushar 11/1 "we agreed to display only clinic name instead of vs in the tab")
  }, [org, tabName, location.pathname]);
  const tenantInitial = (tenantName.slice(0, 1) || 'W').toUpperCase();
  const iconLogoUrl = mediaUrl(org?.identity?.logoIconPath);
  const fullLogoUrl = mediaUrl(org?.identity?.logoFullPath);
  const userEmail = claims?.email ?? 'user@voicespectrum.ai';
  // v12.10.9 (#1254): the person's own name and main group (Settings › Security), not the email's local part / "Administrator".
  const { me: secMe } = useAccess();
  const realName = secMe?.user && (secMe.user.firstName || secMe.user.lastName) ? `${secMe.user.firstName} ${secMe.user.lastName}`.trim() : '';
  const userName = secMe?.isSupport ? 'VoiceSpectrum Support' : realName || userEmail.split('@')[0] || 'User';
  const userInitial = realName && !secMe?.isSupport
    ? `${(secMe!.user.firstName || '').slice(0, 1)}${(secMe!.user.lastName || '').slice(0, 1)}`.toUpperCase()
    : (secMe?.isSupport ? userName.slice(0, 2).toUpperCase() : (userEmail.trim()[0] ?? userName[0] ?? '?').toUpperCase());   // v12.10.9.4 (#1339 F5): one letter with no name
  const userPhoto = secMe?.isSupport ? null : secMe?.user?.photo ?? null;   // v12.10.9.3 (#1306)
  const userRole = secMe?.isSupport ? 'Support session' : secMe?.user?.groupNames?.[0] ?? (secMe?.user ? '' : 'Administrator');

  // v11.8.5.2: never show a broken-image icon. Default to the monogram tile +
  // name/slug; only swap to the logo <img> when it actually loads. A stale or
  // unservable stored path trips onError and falls back to the monogram.
  const [iconFailed, setIconFailed] = useState(false);
  const [fullFailed, setFullFailed] = useState(false);
  useEffect(() => { setIconFailed(false); }, [iconLogoUrl]);
  useEffect(() => { setFullFailed(false); }, [fullLogoUrl]);
  const showFull = Boolean(fullLogoUrl) && !fullFailed;
  const showIcon = Boolean(iconLogoUrl) && !iconFailed;

  useEffect(() => {
    function onDocClick(event: MouseEvent) {
      const t = event.target as HTMLElement;
      if (t.closest('.profile-menu') || t.closest('.sb-card-trigger') || t.closest('.tm-avatar') || t.closest('.fr-layer')) return;   // v12.10.25 (#2106): the tour's own buttons keep the menu open
      setMenuOpen(false);
    }
    if (menuOpen) document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [menuOpen]);

  useEffect(() => { setDrawerOpen(false); setMenuOpen(false); }, [location.pathname, location.search]);
  // v12.10.25 (#2106): the Get familiar tour opens / closes the profile menu (Preferences, Sign out steps).
  useEffect(() => {
    const on = (e: Event) => { const open = !!(e as CustomEvent<{ open?: boolean }>).detail?.open; if (open) setMenuAnchor('card'); setMenuOpen(open); };
    window.addEventListener(FIRST_RUN_MENU_EVENT, on);
    return () => window.removeEventListener(FIRST_RUN_MENU_EVENT, on);
  }, []);   // v12.10.11.1 (#1475): + search - a Help topic changes ?s= only

  function toggleRail() {
    setRailed((value) => {
      const next = !value;
      try { localStorage.setItem('vs_sidebar_rail', next ? '1' : '0'); } catch { /* ignore */ }
      return next;
    });
  }

  function go(to: string) {
    // A page (e.g. Settings) may intercept to confirm unsaved changes before leaving.
    if (navGuard.attempt(to)) return;
    // v12.10.9.4 (#1380): the left menu's Messages always opens the default view (filters reset, even when already open).
    if (to === '/messages') { navigate(to, { state: { menuReset: Date.now() } }); return; }
    navigate(to);
  }


  function handleLogout() {
    setMenuOpen(false);
    // v12.10.9.4 (#1365): Leave on a support visit goes straight back to Support Ops / Platform Ops
    const visit = secMe?.isSupport ? readSupportVisit() : null;
    logout();
    if (visit) { clearSupportVisit(); window.location.assign(visit.back); return; }
    navigate('/login', { replace: true });
  }

  const path = location.pathname;
  // v12.10.11.1 (#1475, UI-PROTO-T56 v1.25 LOCKED): the Help tab (/help) keeps this menu and account card, but each item
  // lists that screen's help topics (?s=) instead of opening the screen; Help itself reads "Getting started".
  const helpMode = path.startsWith('/help');
  const helpRail = (() => { const s = searchParams.get('s'); return s && ['start', 'messages', 'followups', 'contacts', 'settings'].includes(s) ? s : 'start'; })();
  // v12.10.9.4 (#1380): Follow-ups is highlighted only while "Due for follow-up" is on in Messages, Messages otherwise.
  const [dueOn, setDueOn] = useState<boolean>(() => { try { const f = (JSON.parse(sessionStorage.getItem('vs.messages.filters') ?? '{}') as { dueOnly?: boolean; fuView?: boolean }); return !!(f.dueOnly || f.fuView); } catch { return false; } });   // v12.10.11.3 (#1527)
  useEffect(() => {
    const on = (e: Event) => setDueOn(!!(e as CustomEvent<{ dueOnly?: boolean }>).detail?.dueOnly);
    window.addEventListener('vs:messages-filters', on);
    return () => window.removeEventListener('vs:messages-filters', on);
  }, []);
  // v12.10.13 (#1601 T87): Click Analyzer - which screen is on show (no ids), installed once; the tracker batches and sends itself.
  useEffect(() => { installUiTracking(); }, []);
  useEffect(() => {
    const scr = screenFromPath(location.pathname, location.search, { followups: dueOn });
    if (scr) trackScreen(scr.name, scr.group);
  }, [location.pathname, location.search, dueOn]);
  const topNavAll: NavDef[] = [
    { key: 'messages', denied: !canMessages, label: 'Messages', to: '/messages', icon: <IconMessages />, match: (p) => p.startsWith('/messages') && !p.includes('follow') && !dueOn },
    { key: 'followups', denied: !canMessages, label: 'Follow-ups', to: '/messages?filter=follow-up', icon: <IconFollowups />, badge: dueCount > 0 && canMessages ? { value: fmtBadge(dueCount), amber: true } : undefined, match: (p) => p.includes('follow') || (p.startsWith('/messages') && dueOn) },
    { key: 'contacts', denied: !canContacts, label: 'Contacts', to: '/contacts', icon: <IconContacts />, match: (p) => p.startsWith('/contacts') },
    { soon: true, key: 'schedule', label: 'Schedule', to: '/schedule', icon: <IconSchedule />, match: (p) => p.startsWith('/schedule') },
    { key: 'reports', denied: !canOpen('rep_calls'), label: 'Reports', to: '/reports', icon: <IconReports />, match: (p) => p.startsWith('/reports') },
  ];
  // v12.10.9.3 (#1329): "Configuration only" support - Settings only.
  const topNav = supportConfigOnly ? [] : topNavAll;
  const accountNav: NavDef[] = [
    { soon: true, key: 'billing', label: 'Billing', to: '/billing', icon: <IconBilling />, match: (p) => p.startsWith('/billing') },
    { key: 'settings', label: 'Settings', to: '/settings', icon: <IconSettings />, match: (p) => p.startsWith('/settings') || p.startsWith('/configuration') },
    // v12.10.11.1 (#1475): Help is on - it opens the Help library in a new browser tab.
    { key: 'help', label: HELP_DESK_MENU_LABEL, to: '/guides', icon: <IconHelp />, match: (p) => p.startsWith('/guides') || p.startsWith('/help') },   // v12.10.25.2 (#2106): Help opens in the app; Browse all articles opens the library tab · v12.10.30.1 (#2264, Tushar 11/3 "Yes, left menu needs to be renamed as well"): caption Help desk
  ];
  // v12.10.11.1 (#1475): in the Help tab every live item opens its help topics; coming-soon items stay greyed.
  function forHelp(item: NavDef): NavDef {
    if (!helpMode || item.soon) return item;
    const k = item.key === 'help' ? 'start' : item.key;
    // v12.10.23.1 (#2102): greyed when none of that item's help topics are for the person (View on the screen is enough).
    const helpDenied = k === 'start' ? false : HELP_RAIL_KEYS.includes(k) ? !helpRailAllowed(k as HelpRail, helpCan) : !!item.denied;
    return { ...item, newTab: false, denied: helpDenied, badge: undefined, label: item.key === 'help' ? 'Getting started' : item.label, to: `/help?s=${k}`, match: () => helpRail === k };
  }

  function navButton(item: NavDef) {
    const active = !item.soon && !item.denied && item.match(path);
    if (item.denied)   // v12.10.9.4 (#1379)
      return (
        <button key={item.key} type="button" className="nav-item soon denied" data-tip={`Your user group doesn't include ${item.label}`} title={`Your user group doesn't include ${item.label}`} aria-disabled="true" tabIndex={-1} onClick={(e) => e.preventDefault()}>
          {item.icon}
          <span className="lab">{item.label}</span>
        </button>
      );
    if (item.soon)   // v12.10.5 (#1127)
      return (
        <button key={item.key} type="button" className="nav-item soon" data-tip={`${item.label} - Coming soon`} title="Coming soon" aria-disabled="true" tabIndex={-1} onClick={(e) => e.preventDefault()}>
          {item.icon}
          <span className="lab">{item.label}</span>
        </button>
      );
    if (item.newTab)   // v12.10.11.1 (#1475): Help opens in a new browser tab
      return (
        <a key={item.key} className="nav-item" href={item.to} target="_blank" rel="noopener" data-tip={`${item.label} - opens in a new tab`}>
          {item.icon}
          <span className="lab">{item.label}</span>
        </a>
      );
    return (
      <button key={item.key} type="button" className={`nav-item${active ? ' on' : ''}`} data-tip={item.label} onClick={() => go(item.to)}>
        {item.icon}
        <span className="lab">{item.label}</span>
        {item.badge && <span className={`pill${item.badge.amber ? ' amber' : ''}`}>{item.badge.value}</span>}
      </button>
    );
  }

  return (
    <>
    {secMe?.isSupport && (
      <div className="vs-support-banner" role="status" data-testid="support-banner">
        <span>
          VoiceSpectrum Support is in {tenantName} · {secMe.support?.level === 'config' ? 'Configuration only' : 'Configuration + Read & write'}
          {secMe.support?.reason ? ` · ${secMe.support.reason}` : ''} · everything is recorded
          {/* v12.10.30 (#2255): the practice is offline - the visit works, the bar says so, "so nobody forgets" */}
          {secMe.practiceOffline ? ` · Practice is OFFLINE (calls: ${secMe.practiceOffline.callLabel}) - staff see the offline page` : ''}
        </span>
        <button type="button" onClick={handleLogout}>Leave</button>
      </div>
    )}
    {/* v12.10.19 (#1894, LOCKED 10/23 S148): stacked under the Support banner - Support, Staging, New version - full width. The
        "new version" bar keeps its own look (Tushar: "keep the existing banner ... just expand to full width"). */}
    {staging && (
      <div className="vs-staging-bar" role="status">
        <span className="tsb-pill">Staging</span>
        <span>Staging - only calls and contacts from test numbers are cleared when you move to Production.</span>
      </div>
    )}
    {updateAvailable && (
      <div className="vs-update-banner vs-update-banner-top" role="status">
        <span>A new version of VoiceSpectrum is available.</span>
        <button type="button" onClick={() => window.location.reload()}>Reload</button>
      </div>
    )}
    <div className={`tenant-app${railed && !narrow ? ' rail' : ''}${drawerOpen ? ' drawer-open' : ''}${helpMode ? ' help-mode' : ''}`}>{/* v12.10.11.2 (#1495) */}
      <MaintenanceOverlay />
      <aside className="sidebar" aria-label="Organization navigation">
        <div className="tenant-id">
          <button className="tenant-id-home" type="button" onClick={() => go(helpMode ? '/help' : '/messages')} aria-label={helpMode ? 'Help home' : 'Open messages'}>
            {helpMode ? (
              /* v12.10.11.3 (#1495): Tushar 10/9 "keep one full width top bar by removing UAT1 logo, it can just say Library or Help" */
              <span className="help-lib">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                </svg>
                <span>VoiceSpectrum Help</span>
              </span>
            ) : showFull ? (
              <img className="tenant-fulllogo" src={fullLogoUrl} alt={tenantName} onError={() => setFullFailed(true)} />
            ) : (
              <>
                <span className="tenant-logo" aria-hidden="true">
                  {showIcon ? <img src={iconLogoUrl} alt="" onError={() => setIconFailed(true)} /> : tenantInitial}
                </span>
                <span className="tenant-meta">
                  <b>{tenantName}</b>
                  <span className="slug">{helpMode ? 'Help' : slug}</span>{/* v12.10.11.1 (#1475) */}
                </span>
              </>
            )}
          </button>
          <button className="sb-collapse" type="button" onClick={toggleRail} aria-label={railed ? 'Expand sidebar' : 'Collapse sidebar'} title={railed ? 'Expand sidebar' : 'Collapse sidebar'}>
            <IconChevronLeft />
          </button>
        </div>

        {helpMode && <div className="sb-sect sb-help-cap">Help topics</div>}{/* v12.10.11.2 (#1495): this menu lists help sections here */}
        {topNav.map(forHelp).map(navButton)}
        <div className="sb-sect">Account</div>
        {accountNav.map(forHelp).map(navButton)}

        <div className="sb-spacer" />

        {/* v12.10.9.3 (#1309): the WHOLE card is one button - avatar, name, group, VoiceSpectrum, version - it opens the profile
            menu (Enter / Space too). (#1308) the version reads "Version x" in muted text, as on the console sign-in. */}
        <div className={`sb-card${menuOpen ? ' menu-open' : ''}`}>
          <button className="sb-card-trigger sb-card-whole" type="button" ref={triggerRef} aria-haspopup="menu" aria-expanded={menuOpen} title="Opens your menu" onClick={() => { setMenuAnchor('card'); setMenuOpen((v) => !v); }}>
            <div className="sb-card-top">
              <span className="av"><span className="av-in">{userPhoto ? <img src={userPhoto} alt="" className="av-img" /> : userInitial}</span></span>
              <div className="who">
                <b title={userEmail || undefined}>{userName}</b>
                <span>{userRole}</span>
              </div>
            </div>
            <div className="sb-card-vs">
              <img className="vs-mark" src="/brand/svg/06_square_favicon_simplified.svg" alt="" />
              <span className="vs-word">VoiceSpectrum</span>
              <span className="vs-ai">AI</span>
            </div>
            <div className="sb-card-version">Version {APP_VERSION}</div>
          </button>
        </div>
      </aside>

      <header className="tenant-mobile-bar">
        <button className="tm-burger" type="button" onClick={() => setDrawerOpen(true)} aria-label="Open navigation">
          <Svg d={<path d="M3 6h18M3 12h18M3 18h18" />} />
        </button>
        <span className="tm-org"><span className="tm-logo">{tenantInitial}</span><b>{tenantName}</b></span>
        <button className="tm-avatar" type="button" onClick={() => { setMenuAnchor('top'); setMenuOpen((v) => !v); }} aria-label="Account"><span>{userPhoto ? <img src={userPhoto} alt="" className="av-img" /> : userInitial}</span></button>
      </header>
      {drawerOpen && <button className="tenant-scrim" type="button" aria-label="Close navigation" onClick={() => setDrawerOpen(false)} />}

      {menuOpen && (
        <div className={`profile-menu open pm-${menuAnchor}${railed && !narrow ? ' rail' : ''}`} role="menu" ref={menuRef}>
          <div className="pm-head">
            <b title={userEmail || undefined}>{userName}</b>
            <span>{userEmail}</span>
          </div>
          {/* v12.10.9.1 (#1280, Tushar 10/6): one entry - "Your account" (both old entries opened the same drawer). */}
          <button type="button" role="menuitem" onClick={() => { setMenuOpen(false); openYourAccount(); }}>
            <IconProfile /> Your account
          </button>
          {/* v12.10.30 (#2259, Tushar 11/3): "by clicking on help desk, everything is loaded on this screen" - Help & Support on My tickets */}
          <button type="button" role="menuitem" data-track="account-menu.help-desk" onClick={() => { setMenuOpen(false); setDrawerOpen(false); go(helpSupportUrl('tickets')); }}>
            <IconHelp /> {HELP_DESK_MENU_LABEL}
          </button>
          {/* v12.10.25 (#2106): the getting-started guides on demand (Help has every guide) */}
          {!secMe?.isSupport && (
            <>
              <button type="button" role="menuitem" onClick={() => { setMenuOpen(false); if (helpMode) navigate('/'); window.setTimeout(() => sendFirstRun({ action: 'tour', guide: 'fam' }), 80); }}>
                <IconHelp /> Take the tour
              </button>
              <button type="button" role="menuitem" onClick={() => { setMenuOpen(false); sendFirstRun({ action: 'checklist', guide: 'fam' }); }}>
                <IconHelp /> Check yourself
              </button>
            </>
          )}
          <div className="pm-sep" />
          <button type="button" role="menuitem" className="pm-signout" onClick={handleLogout}>
            <IconSignout /> Sign out
          </button>
        </div>
      )}

      <main className="tenant-main">
        {/* v12.10.19 (#1894): the "new version" and Staging bars moved above the app (full width) - see the top of this component. */}
        {supportMode && !secMe?.isSupport && (
          <div className="tenant-app-support-stripe">
            Support access mode. You are viewing {slug}. Tenant changes are audited. (v{APP_VERSION})
          </div>
        )}
        <Outlet />
      </main>
      <IdleLogoutGuard />
      <FirstRunHost helpMode={helpMode} />{/* v12.10.25 (#2106) */}
    </div>
    </>
  );
}
